<template>
<div>
  <transition name="slide-fade" mode="out-in">
  <router-view/>
  </transition>
</div>
</template>

<script>

export default {
  name: 'needs_analysis',

  data () {
    return {
    }
  },
  mounted () {
  }
}
</script>

<style>
.slide-enter-active,
.slide-leave-active{
  transition:opacity 0.8s,tranform 0.8s;
}
.slide-enter,
.slide-leave-to{
  opacity: 0;
  transform: translateX(-30%);
}

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>